import React, { JSX } from 'react';
import GameModal from '../../GameModal/GameModal.tsx';
import {EnteredGameRow, StartWordRow, EndWordRow} from '../../../games/weaver/GameRow.tsx';
import { GameType } from '../../../types/GameType.ts';
import { getGameConfig, WeaverGameConfig } from '../../../types/GameConfig.ts';

import './YesterdayModal.css';

interface WeaverYesterdayModalProps {
  isOpen: boolean;
  onClose: () => void;
  gameType: GameType;
}

class WeaverYesterdayModal extends React.Component<WeaverYesterdayModalProps> {
  getModalContent() {
    const gameType = this.props.gameType;
    
    // Get yesterday's optimal path for Weaver games
    let yesterdayOptimalPath: string[] = [];
    if (gameType === GameType.WEAVER || gameType === GameType.WEAVER_X) {
      const gameConfig = getGameConfig(gameType) as WeaverGameConfig;
      yesterdayOptimalPath = gameConfig.getYesterdayOptimalPath();
    }
    const startWord = yesterdayOptimalPath[0];
    const endWord = yesterdayOptimalPath.slice(-1)[0];
    const rowLength = Math.max(...yesterdayOptimalPath.map(word => word.length));
    const rows: JSX.Element[] = [];
    
    rows.push(
      <div key={startWord} className='yesterdayGameBoardRow'>
        <StartWordRow 
          rowLength={rowLength}
          word={startWord} 
        />
      </div>
    );

    for (let i = 1; i < yesterdayOptimalPath.length - 1; i++) {
      rows.push(
        <div key={yesterdayOptimalPath[i]} className='yesterdayGameBoardRow'>
          <EnteredGameRow 
            rowLength={rowLength}
            word={yesterdayOptimalPath[i]}
            previousWord={yesterdayOptimalPath[i-1]}
            endWord={endWord}
            gameType={gameType}
          />
        </div>
      );
    }

    rows.push(
      <div key={endWord} className='yesterdayGameBoardRow'>
        <EndWordRow 
          rowLength={rowLength}
          word={endWord} 
          lastGameWord={endWord} 
        />
      </div>
    );

    return (
      <div className='yesterdayModalContentContainer'>
        <div className='yesterdayOptimalText'>
          Yesterday's optimal: {yesterdayOptimalPath.length - 1}
        </div>
        <div className={`yesterdayGameBoardContainer ${gameType === GameType.WEAVER_X ? 'weaverX' : ''}`}>
          {rows}
        </div>
        <div className='yesterdayExplanation'>
          This is just one optimal path.
          <br />
          There may be others!
        </div>
      </div>
    );
  }

  render() {
    return (
      <GameModal
        title='Yesterday'
        content={this.getModalContent()}
        isOpen={this.props.isOpen}
        onClose={this.props.onClose}
      />
    );
  }
}

export default WeaverYesterdayModal; 